// Online/offline wording shared by every ping status dot, the Overview
// "Live Status" card and the Inventory Ping Status filter, so they all
// explain the same backend rule: online while data has arrived within the
// org's pingStatusThreshold minutes.

export const PING_STATUS_COLORS = {
  online: "#008A15",
  offline: "#8F8F8F",
};

export const formatThreshold = (minutes) => {
  if (minutes < 60) return `${minutes} minute${minutes !== 1 ? "s" : ""}`;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const hourPart = `${hours} hour${hours !== 1 ? "s" : ""}`;
  return mins > 0 ? `${hourPart} ${mins} minute${mins !== 1 ? "s" : ""}` : hourPart;
};

// A table column can hide its ping dot through the prop or its column config
// (Data Download sets disableActiveStatus in VehicleSearchTableColumns).
export const isPingDotHidden = ({ disableActiveStatus, config } = {}) =>
  disableActiveStatus === true || config?.disableActiveStatus === true;

export const getOnlineDefinition = (entityLabel, threshold) =>
  threshold != null
    ? `${entityLabel} is actively communicating with the platform. Data received within the last ${formatThreshold(threshold)}.`
    : `${entityLabel} is actively communicating with the platform.`;

export const getOfflineDefinition = (entityLabel, threshold) => {
  const entity = String(entityLabel || "").toLowerCase();
  return threshold != null
    ? `No data received from the ${entity} for the last ${formatThreshold(threshold)}.`
    : `No data received from the ${entity} recently.`;
};

// A dot's own state for its tooltip; null/undefined (state unknown) explains both.
export const getDotStatus = (online) => {
  if (online === undefined || online === null) return undefined;
  return online ? "online" : "offline";
};

// status: "online" | "offline" returns that one row; anything else returns both.
export const getPingStatusDefinitionRows = ({ entityLabel, threshold, status }) => {
  const rows = [
    {
      key: "online",
      label: "Online",
      description: getOnlineDefinition(entityLabel, threshold),
      color: PING_STATUS_COLORS.online,
    },
    {
      key: "offline",
      label: "Offline",
      description: getOfflineDefinition(entityLabel, threshold),
      color: PING_STATUS_COLORS.offline,
    },
  ];
  return status === "online" || status === "offline"
    ? rows.filter((row) => row.key === status)
    : rows;
};
